// src/components/SoTheoDoi.js
import React, { useCallback, useEffect, useState } from "react";
import { fetchData } from "../services/api";

// ============================================================
// 📒 SỔ THEO DÕI — chỉ chủ nhà (Đợt N8, 15/09/2026)
// ------------------------------------------------------------
// Chân dung 5.4. Anh chốt 15/09 (chân dung mục 10), mockup N8_khu_chu_nha.html:
//   Hôm nay  — ai đã ghé (giờ, lời nhắn), ai chưa, lần cuối điểm danh (07/09)
//   Nhật ký  — MỌI hoạt động (CN1): *"công cụ đo lường việc mình làm phần mềm"*
//   Con số   — theo MỤC (CN2 = A). Theo NGƯỜI để sau 2–3 tháng (5.3) — đừng thêm
//              cột theo người vào bảng này trước khi anh bảo.
//
// ⚠️ Máy chủ đã chặn thành viên thường (403). Trang Quản trị cũng chỉ admin vào.
// ============================================================

const THE = [
  { ma: "hom-nay", ten: "Hôm nay" },
  { ma: "nhat-ky", ten: "Nhật ký" },
  { ma: "con-so", ten: "Con số" },
];

const TEN_TUAN = ["7 ngày qua", "Tuần trước", "2 tuần trước", "3 tuần trước"];

function HomNay({ ds }) {
  return (
    <ul className="std-ds">
      {ds.map((n) => (
        <li key={n.id} className={`std-dong ${n.da_diem_danh ? "" : "std-chua"}`}>
          <span className="std-dau">{n.da_diem_danh ? "✅" : "○"}</span>
          <span>
            <strong>{n.full_name}</strong>{" "}
            {n.da_diem_danh ? (
              <>
                {n.gio}
                {n.ghi_chu && <em> — “{n.ghi_chu}”</em>}
              </>
            ) : n.so_ngay_tu_lan_cuoi === null ? (
              "chưa ghé · chưa điểm danh lần nào"
            ) : (
              <>
                chưa ghé · lần cuối điểm danh <strong>{n.so_ngay_tu_lan_cuoi === 1 ? "hôm qua" : `${n.so_ngay_tu_lan_cuoi} ngày trước`}</strong>
              </>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}

function NhatKy({ ds, thanhVien, nguoi, onDoiNguoi, soNgay, onDoiSoNgay }) {
  // Gom theo ngày: "Hôm nay", "Hôm qua", rồi ngày cụ thể.
  const nhom = [];
  ds.forEach((d) => {
    const nhan = d.so_ngay_truoc === 0 ? "Hôm nay" : d.so_ngay_truoc === 1 ? "Hôm qua" : d.ngay;
    if (!nhom.length || nhom[nhom.length - 1].nhan !== nhan) nhom.push({ nhan, dong: [] });
    nhom[nhom.length - 1].dong.push(d);
  });
  return (
    <>
      <div className="std-loc">
        <button className={`mv-loc ${nguoi === null ? "mv-loc-bat" : ""}`} onClick={() => onDoiNguoi(null)}>
          Cả nhà
        </button>
        {thanhVien.map((t) => (
          <button key={t.id} className={`mv-loc ${nguoi === t.id ? "mv-loc-bat" : ""}`} onClick={() => onDoiNguoi(t.id)}>
            {t.full_name}
          </button>
        ))}
        <select className="std-so-ngay" value={soNgay} onChange={(e) => onDoiSoNgay(Number(e.target.value))}>
          <option value={1}>Hôm nay</option>
          <option value={7}>7 ngày</option>
          <option value={31}>31 ngày</option>
        </select>
      </div>
      {ds.length === 0 ? (
        <p className="kho-anh-ghi">Chưa có hoạt động nào trong khoảng này.</p>
      ) : (
        nhom.map((g) => (
          <div key={g.nhan}>
            <div className="std-ngay">{g.nhan}</div>
            <ul className="std-ds">
              {g.dong.map((d, i) => (
                <li key={`${g.nhan}-${i}`} className="std-dong">
                  <span className="std-gio">{d.gio}</span>
                  <span className="std-dau">{d.bieu_tuong}</span>
                  <span>{d.chu}</span>
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
      {ds.length >= 500 && <p className="kho-anh-ghi">Chỉ hiện 500 dòng mới nhất — chọn khoảng ngắn hơn hoặc lọc theo người.</p>}
    </>
  );
}

function ConSo({ du }) {
  return (
    <>
      <div className="bang-cuon">
        <table className="std-bang">
          <thead>
            <tr>
              <th>Mục</th>
              {TEN_TUAN.slice(0, du.so_tuan).map((t) => <th key={t}>{t}</th>)}
            </tr>
          </thead>
          <tbody>
            {du.bang.map((d) => (
              <tr key={d.ma}>
                <td>{d.ten}</td>
                {d.cot.map((so, i) => <td key={i}>{so === null ? "–" : so}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="kho-anh-ghi">
        "–" = tuần đó chưa đo được: việc nhờ và lịch thêm chỉ có giờ từ khi đợt N8 lên máy chủ. Con số theo từng người
        để sau khi có 2–3 tháng dữ liệu (anh chốt 15/09).
      </p>
    </>
  );
}

function SoTheoDoi() {
  const [the, setThe] = useState("hom-nay");
  const [homNay, setHomNay] = useState(null);
  const [nhatKy, setNhatKy] = useState(null);
  const [conSo, setConSo] = useState(null);
  const [nguoi, setNguoi] = useState(null);
  const [soNgay, setSoNgay] = useState(7);
  const [loi, setLoi] = useState(false);

  const taiNhatKy = useCallback(() => {
    setNhatKy(null);
    const q = `quan-tri/so-theo-doi/nhat-ky?ngay=${soNgay}${nguoi ? `&nguoi=${nguoi}` : ""}`;
    fetchData(q).then(setNhatKy).catch(() => setLoi(true));
  }, [nguoi, soNgay]);

  useEffect(() => {
    setLoi(false);
    if (the === "hom-nay") fetchData("quan-tri/so-theo-doi/hom-nay").then(setHomNay).catch(() => setLoi(true));
    if (the === "nhat-ky") {
      if (!homNay) fetchData("quan-tri/so-theo-doi/hom-nay").then(setHomNay).catch(() => {});
      taiNhatKy();
    }
    if (the === "con-so") fetchData("quan-tri/so-theo-doi/con-so").then(setConSo).catch(() => setLoi(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [the, taiNhatKy]);

  const dangTai = { "hom-nay": homNay, "nhat-ky": nhatKy, "con-so": conSo }[the] === null;

  return (
    <div className="card" id="so-theo-doi">
      <h3>📒 Sổ theo dõi</h3>
      <p className="kho-anh-ghi" style={{ marginTop: -4 }}>
        Chỉ bạn thấy. Để đo app được dùng ra sao — không phải để trách ai.
      </p>
      <div className="std-the" role="tablist">
        {THE.map((t) => (
          <button
            key={t.ma}
            role="tab"
            aria-selected={the === t.ma}
            className={`std-nut-the ${the === t.ma ? "bat" : ""}`}
            onClick={() => setThe(t.ma)}
          >
            {t.ten}
          </button>
        ))}
      </div>

      {loi ? (
        <p className="kho-anh-ghi sao-luu-loi">⚠️ Không tải được. Bấm F5 thử lại.</p>
      ) : dangTai ? (
        <p className="kho-anh-ghi">⏳ Đang tải…</p>
      ) : the === "hom-nay" ? (
        <HomNay ds={homNay} />
      ) : the === "nhat-ky" ? (
        <NhatKy
          ds={nhatKy}
          thanhVien={(homNay || []).map((n) => ({ id: n.id, full_name: n.full_name }))}
          nguoi={nguoi}
          onDoiNguoi={setNguoi}
          soNgay={soNgay}
          onDoiSoNgay={setSoNgay}
        />
      ) : (
        <ConSo du={conSo} />
      )}
    </div>
  );
}

export default SoTheoDoi;
